import React from "react";
import "./FreeText.scss";

interface FreeTextProps {
  content: string;
}

const FreeText = ({ content }: FreeTextProps) => {
  return (
    <div className="quill-rendered-content bg-white">
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};


export default FreeText;
